const {h, render, Component} = require('preact');
const {route} = require('preact-router')
const ClaimView = require('../../../views/gplus/claim')

class Claim extends Component {
  constructor(props) {
    super(props);
    this.claimDetails = this.claimDetails.bind(this);
  }

  claimDetails() {
    route(`/customer_support/web/claim/summary?claimId=${this.props.item.claimId}`);
  }

  render(props, state) {
    return (
      <ClaimView
        claim={this.props.item}
        claimDetails={this.claimDetails.bind(this)}
      />
    )
  }

}

module.exports = Claim
